import { render, staticRenderFns } from "./Childs.vue?vue&type=template&id=713d1bdb&scoped=true&"
import script from "./Childs.vue?vue&type=script&lang=js&"
export * from "./Childs.vue?vue&type=script&lang=js&"
import style0 from "./Childs.vue?vue&type=style&index=0&id=713d1bdb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713d1bdb",
  null
  
)

export default component.exports